import React from 'react';
import { IDirectoryEntry } from 'services/CrmApi/types/DirectoryEntry';
import { UserDate } from '../UserDate/UserDate';
import { isCompanyProfile } from 'containers/CRM/helpers';

export interface ICompanyPageTitleRightPartProps {
  directoryEntry?: IDirectoryEntry;
}

export const CompanyPageTitleRightPart: React.FC<ICompanyPageTitleRightPartProps> = ({ 
  directoryEntry
}) => {
  if (!directoryEntry?.profile || !isCompanyProfile(directoryEntry?.profile)) {
    return null;
  }

  return (
    <div className="flex flex-col gap-[5px]">
      <UserDate text="Created by:" date={directoryEntry?.createdDate} user={directoryEntry?.createdBy} />
      <UserDate text="Modified by:" date={directoryEntry?.updatedDate} user={directoryEntry?.updatedBy} />
    </div>
  );
}
